import { Grid } from '@mui/material';
import React, { Fragment } from 'react';
import useFetchData from '../../../helpers/useFetch';
import AppURL from '../../../constants/AppURL';
import ProductSaleCreateView from '../../../components/inventory/create/product_sales/ProductSaleCreateView';
import ProductSaleListView from '../../../components/inventory/create/product_sales/ProductSaleListView';

const ProductSalesCreateView = () => {
    const { data, loading, error, refetch } = useFetchData(AppURL.InventoryURL + "inventory/product/master/options/list/view/");
  
    return (
        <Fragment>
            <Grid container spacing={3}>
                <Grid item xl={4} md={5} sm={12} xs={12} lg={4}>
                    <ProductSaleCreateView loading={loading} data={data} />
                </Grid>
                <Grid item xl={8} md={7} sm={12} xs={12} lg={8}>
                    <ProductSaleListView />
                </Grid>
            </Grid>
        </Fragment>
    )
}

export default ProductSalesCreateView